import React from 'react'
import { MoteCard } from '@mote/presentation'
import {
  apiClient,
  useMoteReactUnreactMutation,
  useTrackMutation
} from '@mote/api'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { MoteCardRichWrapper } from '@mote/presentation/src/moteCard/rich/MoteCardRichWrapper'

export const EmbedScreen = () => {
  const { id: moteId } = useParams()
  const [mote, setMote] = React.useState(null)
  const [error, setError] = React.useState(null)
  const [loading, setLoading] = React.useState(true)

  const { mutate: emojiReact } = useMoteReactUnreactMutation({
    moteId: mote?.moteId
  })

  const { mutate: track } = useTrackMutation()

  const [myReactions, setMyReactions] = React.useState(null)

  const useMoteCardV2 = React.useMemo(
    () => Boolean(mote?.labs?.zidaneMode),
    [mote]
  )

  const shouldEnableReactions = React.useCallback(() => {
    if (!mote) return false

    const result =
      mote.availableReactions?.length > 0 ||
      mote.availableUnreactions?.length > 0
    return result
  }, [mote])

  const toggleEmoji = React.useCallback(
    reaction => {
      const isEnabled = !myReactions.includes(reaction)

      if (!isEnabled) {
        setMyReactions(myReactions.filter(item => item !== reaction))
      } else {
        setMyReactions([reaction])
        track({
          variables: {
            event: 'Mote Reaction',
            reaction,
            creator_cohort: mote.parentMote.labs?.labsCohort,
            author_user_id: mote.parentMote.createdByUserId,
            author_asset_id: mote.parentMote.moteId
          }
        })
      }

      emojiReact({
        variables: {
          isEnabled,
          reaction
        }
      }).catch(console.error)
    },
    [myReactions]
  )

  React.useEffect(() => {
    apiClient
      .extend({
        timeout: 30000,
        retry: {
          limit: 3,
          methods: ['post']
        }
      })
      .post(`v1/m/status/${moteId}`, {
        json: {}
      })
      .json()
      .then(data => {
        setMote(data.moteStatus)
        setMyReactions(data.moteStatus.myReactions)
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }, [])

  if (error || !moteId) {
    return <div>Could not load this mote...</div>
  }

  if (loading || !mote) {
    return <div>Loading your mote...</div>
  }

  return (
    <Root>
      {!useMoteCardV2 && (
        <MoteCard
          moteId={mote?.moteId}
          username={mote?.createdByName}
          audioUrl={mote?.playbackLocation}
          shouldEnableReactions={false}
        />
      )}
      {useMoteCardV2 && (
        <MoteCardRichWrapper
          createdByName={mote.createdByName}
          createdByAvatar={mote.createdByAvatar}
          createdByUserId={mote.createdByUserId}
          audioUrl={mote.playbackLocation}
          theme={mote.theme}
          niceTitle={mote.niceTitle}
          transcript={mote.transcriptDisplay}
          waveform={mote.waveform}
          waveformFrameMilliseconds={mote.waveformFrameMilliseconds}
          onEmojiSelected={toggleEmoji}
          myReactions={myReactions}
          shouldEnableReactions={shouldEnableReactions()}
          moteId={mote?.moteId}
          showLogo
        />
      )}
    </Root>
  )
}

const Root = styled.div``
